import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store/state";
import { ShareType } from "../../../types/Enums";
import { DonationSummaryHeader, DonationSummaryWrapper, SummmaryOrganizationsList, TotalTable } from "./DonationSummary.style";
import { calculateDonationBreakdown } from "../../../utils/donationCalculations";
export interface DonationSummaryText {
  single_donation_text: string;
  monthly_donation_text: string;
  smart_distribution_title: string;
  operations_summary_label: string;
  total_label: string;
}
export const DonationSummary: React.FC<{
  text: DonationSummaryText;
}> = t0 => {
  const $ = _c(52);
  const {
    text
  } = t0;
  const donation = useSelector(_temp);
  const causeAreas = useSelector(_temp2) || [];
  const {
    selectionType,
    causeAreaAmounts: t1,
    orgAmounts: t2,
    causeAreaDistributionType: t3,
    selectedCauseAreaId,
    recurring,
    operationsPercentageModeByCauseArea: t4,
    operationsPercentageByCauseArea: t5,
    smartDistributionTotal: t6,
    globalOperationsEnabled: t7,
    globalOperationsPercentage: t8,
    operationsConfig
  } = donation;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const causeAreaAmounts = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const orgAmounts = t10;
  let t11;
  if ($[4] !== t3) {
    t11 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const causeAreaDistributionType = t11;
  let t12;
  if ($[6] !== t4) {
    t12 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const operationsPercentageModeByCauseArea = t12;
  let t13;
  if ($[8] !== t5) {
    t13 = t5 === undefined ? {} : t5;
    $[8] = t5;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const operationsPercentageByCauseArea = t13;
  const smartDistributionTotal = t6 === undefined ? 0 : t6;
  const globalOperationsEnabled = t7 === undefined ? false : t7;
  const globalOperationsPercentage = t8 === undefined ? 5 : t8;
  let t14;
  if ($[10] !== causeAreaAmounts || $[11] !== causeAreaDistributionType || $[12] !== causeAreas || $[13] !== globalOperationsEnabled || $[14] !== globalOperationsPercentage || $[15] !== operationsConfig || $[16] !== operationsPercentageByCauseArea || $[17] !== operationsPercentageModeByCauseArea || $[18] !== orgAmounts || $[19] !== selectedCauseAreaId || $[20] !== selectionType || $[21] !== smartDistributionTotal || $[22] !== text.operations_summary_label || $[23] !== text.smart_distribution_title) {
    bb0: {
      const summaryItems = [];
      if (selectedCauseAreaId === -1 && smartDistributionTotal > 0) {
        const operationsAmount = globalOperationsEnabled ? Math.round(smartDistributionTotal * globalOperationsPercentage / 100) : 0;
        summaryItems.push({
          id: -1,
          name: text.smart_distribution_title,
          amount: smartDistributionTotal - operationsAmount,
          orgs: []
        });
        if (operationsAmount > 0 && operationsConfig?.operationsCauseAreaId !== undefined) {
          summaryItems.push({
            id: operationsConfig.operationsCauseAreaId,
            name: text.operations_summary_label,
            amount: operationsAmount,
            orgs: []
          });
        }
        t14 = {
          summaryItems,
          sum: smartDistributionTotal
        };
        break bb0;
      }
      const breakdown = calculateDonationBreakdown(causeAreaAmounts, orgAmounts, causeAreaDistributionType, operationsPercentageModeByCauseArea, operationsPercentageByCauseArea, causeAreas, selectionType || "single", selectedCauseAreaId, globalOperationsEnabled, globalOperationsPercentage, operationsConfig?.excludedCauseAreaIds || [], operationsConfig?.operationsCauseAreaId, smartDistributionTotal);
      const hasCombinedSmartDistribution = selectionType === "multiple" && smartDistributionTotal > 0;
      const displayedBreakdown = hasCombinedSmartDistribution ? calculateDonationBreakdown(causeAreaAmounts, orgAmounts, causeAreaDistributionType, operationsPercentageModeByCauseArea, operationsPercentageByCauseArea, causeAreas, selectionType, selectedCauseAreaId, globalOperationsEnabled, globalOperationsPercentage, operationsConfig?.excludedCauseAreaIds || [], operationsConfig?.operationsCauseAreaId) : breakdown;
      if (hasCombinedSmartDistribution) {
        const directAmount = Object.values(displayedBreakdown.causeAreaAmounts).reduce(_temp3, 0);
        summaryItems.push({
          id: -1,
          name: text.smart_distribution_title,
          amount: breakdown.totalAmount - breakdown.operationsAmount - directAmount,
          orgs: []
        });
      }
      causeAreas.forEach(area => {
        const areaAmount = displayedBreakdown.causeAreaAmounts[area.id];
        if (!areaAmount || areaAmount <= 0) {
          return;
        }
        const orgs = [];
        if (causeAreaDistributionType[area.id] === ShareType.CUSTOM) {
          area.organizations.forEach(org => {
            const orgAmount = displayedBreakdown.organizationAmounts[org.id];
            if (orgAmount && orgAmount > 0) {
              orgs.push({
                id: org.id,
                name: org.name,
                amount: orgAmount
              });
            }
          });
        }
        summaryItems.push({
          id: area.id,
          name: area.name,
          amount: areaAmount,
          orgs: orgs.length > 0 ? orgs : undefined
        });
      });
      if (breakdown.operationsAmount > 0 && operationsConfig?.operationsCauseAreaId !== undefined) {
        let t15;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t15 = [];
          $[25] = t15;
        } else {
          t15 = $[25];
        }
        let t16;
        if ($[26] !== breakdown || $[27] !== operationsConfig.operationsCauseAreaId || $[28] !== text.operations_summary_label) {
          t16 = {
            id: operationsConfig.operationsCauseAreaId,
            name: text.operations_summary_label,
            amount: breakdown.operationsAmount,
            orgs: t15
          };
          $[26] = breakdown;
          $[27] = operationsConfig.operationsCauseAreaId;
          $[28] = text.operations_summary_label;
          $[29] = t16;
        } else {
          t16 = $[29];
        }
        summaryItems.push(t16);
      }
      let t15;
      if ($[30] !== breakdown || $[31] !== summaryItems) {
        t15 = {
          summaryItems,
          sum: breakdown.totalAmount
        };
        $[30] = breakdown;
        $[31] = summaryItems;
        $[32] = t15;
      } else {
        t15 = $[32];
      }
      t14 = t15;
    }
    $[10] = causeAreaAmounts;
    $[11] = causeAreaDistributionType;
    $[12] = causeAreas;
    $[13] = globalOperationsEnabled;
    $[14] = globalOperationsPercentage;
    $[15] = operationsConfig;
    $[16] = operationsPercentageByCauseArea;
    $[17] = operationsPercentageModeByCauseArea;
    $[18] = orgAmounts;
    $[19] = selectedCauseAreaId;
    $[20] = selectionType;
    $[21] = smartDistributionTotal;
    $[22] = text.operations_summary_label;
    $[23] = text.smart_distribution_title;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const {
    summaryItems: summaryItems_0,
    sum
  } = t14;
  if (sum === 0) {
    return null;
  }
  const t15 = recurring ? text.monthly_donation_text : text.single_donation_text;
  let t16;
  if ($[33] !== t15) {
    t16 = <DonationSummaryHeader data-cy="donation-type">{t15}</DonationSummaryHeader>;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== summaryItems_0) {
    t17 = summaryItems_0.map(_temp5);
    $[35] = summaryItems_0;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17) {
    t18 = <SummmaryOrganizationsList cellSpacing={0}><tbody>{t17}</tbody></SummmaryOrganizationsList>;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== text.total_label) {
    t19 = <td data-cy="summary-total-label">{text.total_label}</td>;
    $[39] = text.total_label;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== sum) {
    t20 = sum.toLocaleString("no-NB");
    $[41] = sum;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20) {
    t21 = <td data-cy="summary-total-amount">{t20} kr</td>;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t19 || $[46] !== t21) {
    t22 = <TotalTable><tbody><tr>{t19}{t21}</tr></tbody></TotalTable>;
    $[45] = t19;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t16 || $[49] !== t18 || $[50] !== t22) {
    t23 = <DonationSummaryWrapper data-cy="donation-summary">{t16}{t18}{t22}</DonationSummaryWrapper>;
    $[48] = t16;
    $[49] = t18;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}
function _temp3(total, amount) {
  return total + amount;
}
function _temp4(org_0) {
  return <tr key={org_0.id}><td style={{
      paddingLeft: 40
    }} data-cy={`summary-org-${org_0.id}-name`}>{org_0.name}</td><td data-cy={`summary-org-${org_0.id}-amount`}>{org_0.amount.toLocaleString("no-NB")} kr</td></tr>;
}
function _temp5(item) {
  return <React.Fragment key={item.id}><tr data-cy={item.id === -1 ? "summary-smart-distribution" : `summary-cause-area-${item.id}`}><td data-cy={item.id === -1 ? "summary-smart-distribution-name" : `summary-cause-area-${item.id}-name`}><strong>{item.name}</strong></td><td data-cy={item.id === -1 ? "summary-smart-distribution-amount" : `summary-cause-area-${item.id}-amount`}>{(!item.orgs || item.orgs.length === 0) && `${item.amount.toLocaleString("no-NB")} kr`}</td></tr>{item.orgs && item.orgs.map(_temp4)}</React.Fragment>;
}